export default __webpack_public_path__ + "static/media/buy-sell-edge.b652eb3f.svg";